import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

export type StateSelectorParams = {
  isLoading: boolean
  isSharedView: boolean
  confidenceLevel: number
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  return {
    isLoading: state.isLoading,
    isSharedView: state.isSharedView,
    confidenceLevel: block?.get<number>('confidenceLevel') || 0.95
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : next.isLoading
    ? false
    : prev.isSharedView !== next.isSharedView || prev.confidenceLevel !== next.confidenceLevel
